import { useCallback } from "react"
import { ArrowUpIcon } from "./icons"

interface Props {
  visible: boolean
}

export function BackToTop({ visible }: Props) {
  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [])

  return (
    <button
      className={`gb-back-to-top${visible ? " gb-back-to-top--visible" : ""}`}
      onClick={scrollToTop}
      type="button"
      aria-label="Back to top"
    >
      <ArrowUpIcon />
    </button>
  )
}
